import loginReducer from "./loginReducer";
import shopDetailReducer from "./shopDetailsReducer";
import { combineReducers } from "redux";
import settingsReducer from "./settingsReducer";
import customerReducer from "./customerReducer";
import taxReducer from "./taxReducer";
import billingPayloadReducer from "./billingPayloadReducer";
import outletReducer from "./outletReducer";
import productListReducer from "./productListReducer";
import loyaltyFullDetailsReducer from "./loyaltyReducer";
import InvoiceReducer from "./InvoiceReducer";
import productsForSearchReducer from "./productsForSearch";

const rootReducer = combineReducers({
  isLoggedIn: loginReducer,
  shopDetails: shopDetailReducer,
  settings: settingsReducer,
  customerDetails: customerReducer,
  taxList: taxReducer,
  billingPayload: billingPayloadReducer,
  outlets: outletReducer,
  products: productListReducer,
  loyaltyFullDetails: loyaltyFullDetailsReducer,
  newInvoicesettings: InvoiceReducer,
  productsForSearch: productsForSearchReducer,
});

export default rootReducer;
